

function Main() {
    return (
        <div className="main_page">
            <div className="main_text">
                <div className="first_text">
                    <div className="big_text">ПИЛАТЕС-РЕТРИТ <br />
                        «ПЕРЕЗАГРУЗКА»</div>
                    {/*<div className="big_text info_text">*В Январе скидка 10%</div>*/}
                </div>
                <div className="second_text">
                    <div className="text_span">C сауной и погружением в частное озеро</div>
                    {/*<div>и погружением в частное озеро</div>*/}
                    <div>День заботы о теле, энергии и внутренней гармонии</div>
                    {/*<div>энергии и внутренней гармонии</div>*/}
                    {/*<div className="text_span">"Femme Fatale"</div>*/}
                </div>
                <div className="third_text">
                    <div>25 Января</div>
                    {/*<div>*осталось 3 места</div>*/}
                </div>
            </div>
            {/*<div className="additional_text">*/}
            {/*    <p>*в часе езды от Лондона</p>*/}
            {/*</div>*/}
            <div className="main_buttons">
                <a href="#coordinators">
                    <button className="button_main">Узнать подробнее</button>
                </a>
            </div>
        </div>
    );
}

export default Main;
